import ForgotPassword from "./forgotPasswordContainer";
export default ForgotPassword;
